<template>
  <BaseModal
    class="modal__overlay"
    :is-show-button-close="false"
  >
    <div
      class="modal"
      @click="() => closeModal()"
    >
      <BasePicture
        class="modal__picture"
        :src
      />
    </div>
  </BaseModal>
</template>

<script lang="ts" setup>
defineProps<{
  src: string;
}>();

const { closeModal } = useModalStore();
</script>

<style scoped>
:global(.modal__overlay) {
  justify-content: center;
  align-items: center;
  padding: 24px;
  background-color: var(--grey-1-20);
}

@media (--md) {
  :global(.modal__overlay) {
    padding: 40px;
  }
}

.modal {
  display: flex;
  max-width: calc(100vw - 80px);
  max-height: calc(100vh - 80px);
  margin: auto;
  overflow: hidden;
}

.modal__picture {
  max-width: 1600px;
  max-height: 1600px;
}

.modal__picture :deep(img) {
  border-radius: 12px;
}
</style>
